import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React__default from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from '../../components/Link/Link.esm.js';
import 'lodash';
import 'qs';
import '@react-hookz/web';
import { useSupportConfig } from '../../hooks/useSupportConfig.esm.js';
import { MicDrop } from './MicDrop.esm.js';
import { StackDetails } from './StackDetails.esm.js';
import { coreComponentsTranslationRef } from '../../translation.esm.js';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';

const useStyles = makeStyles(
  (theme) => ({
    container: {
      padding: theme.spacing(8),
      [theme.breakpoints.down("xs")]: {
        padding: theme.spacing(2)
      }
    },
    title: {
      paddingBottom: theme.spacing(5),
      [theme.breakpoints.down("xs")]: {
        paddingBottom: theme.spacing(4),
        fontSize: theme.typography.h3.fontSize
      }
    },
    subtitle: {
      color: theme.palette.textSubtle
    }
  }),
  { name: "BackstageErrorPage" }
);
function ErrorPage(props) {
  const {
    status = "",
    statusMessage,
    additionalInfo,
    supportUrl,
    stack
  } = props;
  const classes = useStyles();
  const navigate = useNavigate();
  const support = useSupportConfig();
  const { t } = useTranslationRef(coreComponentsTranslationRef);
  return /* @__PURE__ */ React__default.createElement(Grid, { container: true, className: classes.container }, /* @__PURE__ */ React__default.createElement(Grid, { item: true, xs: 12, sm: 8, md: 4 }, /* @__PURE__ */ React__default.createElement(
    Typography,
    {
      "data-testid": "error",
      variant: "body1",
      className: classes.subtitle
    },
    t("errorPage.subtitle", { status, statusMessage })
  ), /* @__PURE__ */ React__default.createElement(Typography, { variant: "body1", className: classes.subtitle }, additionalInfo), /* @__PURE__ */ React__default.createElement(Typography, { variant: "h2", className: classes.title }, t("errorPage.title")), /* @__PURE__ */ React__default.createElement(Typography, { variant: "h6", className: classes.title }, /* @__PURE__ */ React__default.createElement(Link, { to: "#", "data-testid": "go-back-link", onClick: () => navigate(-1) }, t("errorPage.goBack")), "... or please", " ", /* @__PURE__ */ React__default.createElement(Link, { to: supportUrl || support.url }, "contact support"), " if you think this is a bug."), stack && /* @__PURE__ */ React__default.createElement(StackDetails, { stack })), /* @__PURE__ */ React__default.createElement(MicDrop, null));
}

export { ErrorPage };
//# sourceMappingURL=ErrorPage.esm.js.map
